module.exports = __webpack_public_path__ + "img/exclusive_icon.942914fc.svg";